import React, {useEffect, useState, useRef} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../components/me-child-header'
import { action_fetch_coupons, action_fetch_wallet, action_fetch_wallet_history_all, action_fetch_wallet_history_earned, action_fetch_wallet_history_expired, action_fetch_wallet_history_used } from '../../../../../store/actions/pages/customer'
import { useStore, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import MeListEmpty from '../../components/list-empty'
import { useMemo } from 'react'
import { Iconfont } from '../../../../components/icon/iconfont'
import { IMAGE_GEEKO_LTD } from '../../../../../constants'
import MeLoading from '../../components/loading'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import fecha from 'fecha'
import Header from "../../../policy/fragments/heading/index"
import { unitPrice } from '../../../../../utils/product'


const WalletCard = props => {
    useStyles(classes)
    const {price, Intl, global} = props

    return (
        <div className={classes.WalletCard}>
            <div className={classes.WalletCredit}>
                <p className={classes.WalletTxt}>{Intl.formatMessage({id: 'wallet_credit'})}</p>
                <p className={classes.WalletPrice}>{unitPrice(price)}</p>
                <p className={classes.WalletMessage}>{Intl.formatMessage({id: 'only_apply_for'},{website:  global?.config?.name || ''})}</p>
            </div>
        </div>
    )
}

const WalletHistory = props => {
    useStyles(classes)
    const {showType, walletHistory, setShowType, Intl} = props

    return (
        <div className={classes.WalletHistory}>
            <div className={classes.HistoryTitle}>
                {Intl.formatMessage({id: 'wallet_history'})}
            </div>
            <div className={classes.HistoryTabs}>
                <div className={`${classes.TabItem}`} onClick={() => setShowType('all')}>
                    <span className={`${showType == 'all'? classes.TabSelect: ''}`}>{Intl.formatMessage({id: 'all'})}</span> 
                </div>
                <div className={`${classes.TabItem}`} onClick={() => setShowType('earned')}>
                    <span className={`${showType == 'earned'? classes.TabSelect: ''}`}>{Intl.formatMessage({id: 'earned'})}</span> 
                </div>
                <div className={`${classes.TabItem}`} onClick={() => setShowType('used')}>
                    <span className={`${showType == 'used'? classes.TabSelect: ''}`}>{Intl.formatMessage({id: 'used'})}</span> 
                </div>
                <div className={`${classes.TabItem}`} onClick={() => setShowType('expired')}>
                    <span className={`${showType == 'expired'? classes.TabSelect: ''}`}>{Intl.formatMessage({id: 'expired'})}</span> 
                </div>
            </div>

            <div className={classes.HistoryList}>
                {
                    walletHistory?.map((item, index) => (
                        <HistoryItem credit={item} key={item?.createTime + index} Intl={Intl}/>
                    ))
                }
                {
                    !walletHistory || walletHistory?.length == 0 ?
                    <div className={classes.NoMore}>{Intl.formatMessage({id: 'no_more_data'})}</div>:
                    <React.Fragment></React.Fragment>
                }
            </div>

        </div>
    )
}

const HistoryItem = props => {

    const {credit, Intl} = props

    const walletType = () => {
        let wallet = credit;
        if(wallet?.targetId){
            return <span> {`${Intl.formatMessage({id: 'order'})} # ${wallet?.targetId}`}</span>
        }
        if(wallet?.expired){
            return <span>{Intl.formatMessage({id: 'expired'})}</span>
        }else{
            if(wallet?.expiredDate){
                return <span>{Intl.formatMessage({id: 'expired_on'},{date: getExpiredDate(wallet?.expiredDate)})}</span>;
            }else{
                return <span>{Intl.formatMessage({id: 'earned'})}</span>
            }
        }
    }

    const getExpiredDate = (time) => {
        if(time == null){
            return ''
        }
        return fecha.format(new Date(parseInt(time)), 'MM/DD/YYYY HH:mm:ss')
    }

    const walletPrice = () => {
        return `${credit?.positive?"+":"-"}${unitPrice(credit?.amount)}`;
    }

    return (
        <div className={classes.HistoryItem}>
            <div className={classes.HistoryCredit}>
                <div className={classes.CreditLeft}>
                    <p>{getExpiredDate(credit?.createTime)}</p>
                </div>
                <div className={classes.CreditCenter}>
                    <p>{credit?.name}</p>
                    <p>{ walletType() }</p>
                </div>
                <div className={classes.CreditRight}>
                    <span className={`${classes.Price} ${credit?.positive ? '': classes.PricePlus}`}>{walletPrice()}</span>
                </div>
            </div>
        </div>
    )
}


const WalletPage = props => {
    useStyles(classes)

    const global = useSelector(state => state.global)
    const pageCustomer = useSelector(state => state.pageCustomer)
    const { wallet, walletHistory, walletHistorySkip, walletHistoryLoading, walletHistoryFinished } = pageCustomer || {}

    const dispatch = useDispatch()
    const Intl = useIntl()
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()

    const [showType, setShowType] = useState("all") // all,earned,used,expired
    const [loading, setLoading] = useState(true)
    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!wallet){
                await WalletPage.fetchData(store, params, query)
            }
		}
    }, [])

    useEffect(() => {
        if(wallet){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[wallet])

    const changeType = (type) => {
        if(type == showType)return
        setLoading(true)
        switch(type){
            case 'all':
                setShowType('all')
                if(!(walletHistoryLoading?.all || walletHistoryFinished?.all)){
                    dispatch(action_fetch_wallet_history_all(0)).then(res => {
                        setLoading(false)
                    }).catch(err => {
                        setLoading(false)
                    })
                } else {
                    setLoading(false)
                }
                break;
            case 'earned':
                setShowType('earned')
                if(!(walletHistoryLoading?.earned || walletHistoryFinished?.earned)){
                    dispatch(action_fetch_wallet_history_earned(0)).then(res => {
                        setLoading(false)
                    }).catch(err => {
                        setLoading(false)
                    })
                } else {
                    setLoading(false)
                }
                break;
            case 'expired':
                setShowType('expired')
                if(!(walletHistoryLoading?.expired || walletHistoryFinished?.expired)){
                    dispatch(action_fetch_wallet_history_expired(0)).then(res => {
                        setLoading(false)
                    }).catch(err => {
                        setLoading(false)
                    })
                } else {
                    setLoading(false)
                }
                break;
            case 'used':
                setShowType('used')
                if(!(walletHistoryLoading?.used || walletHistoryFinished?.used)){
                    dispatch(action_fetch_wallet_history_used(0)).then(res => {
                        setLoading(false)
                    }).catch(err => {
                        setLoading(false)
                    })
                } else {
                    setLoading(false)
                }
                break;
            default:
                setLoading(false)
                break;
        }
    }


    return <div classes={classes.WalletPage}>
        <div className={classes.WalletHeader}>
            <Header
                centerSlot={<span style={{color:"#fff"}}>{Intl.formatMessage({id: 'wallet'})}</span>} 
                rightSlot={
                    <a href={'/policy/wallet-policy'}>
                        <Iconfont style={{color:"#fff"}}>&#xe73f;</Iconfont>
                    </a>
                }
                textStyle={{color: '#fff',}}
                style={{backgroundColor:'transparent',borderBottom:'none'}}
            />

            <WalletCard price={wallet} Intl={Intl} global={global}/>
            <div className={classes.HeaderBack}></div>

            <WalletHistory walletHistory={walletHistory?.[showType]} showType={showType} setShowType={type => changeType(type)} Intl={Intl}/>
        </div>


        <MeLoading loading={loading} />
    </div>
}

WalletPage.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_wallet(headers))
    await store.dispatch(action_fetch_wallet_history_all(0,headers))
}

export default WalletPage